import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'nns-item-folder-list',
  styles: [`
    :host {
      box-sizing:border-box;
      width:100%;
    }
    .nns-item-folder-link {
      box-sizing:border-box;
      color:rgba(0,0,0,0.80);
      position:relative;
      display:block;
      border-bottom:1px solid #dcdcdc;
    }
    .nns-item-folder-layer {
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      display:block;
      background:#fff;
    }
    .nns-item-folder-main {
      position:relative;
      z-index:5;
      width:100%;
      height:100%;
      padding:12px;
      box-sizing:border-box;
      overflow:hidden;
      transition:all 0.1s ease-out;
      border-radius:2px;
    }
    .nns-item-folder-link:hover {color:rgba(0,0,0,0.80);}
    .nns-item-folder-link:hover .nns-item-folder-main {background:rgba(236,239,241,0.28);}

    .nns-item-folder-name-text {
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      font-size:15px;
      font-weight:bold;
      margin:0 0 0 8px;
    }
    .nns-item-folder-notes {padding:0 0 0 8px;}

    @media print {
      .nns-item-folder-name-text{
        margin-left: 0;
      }
      .nns-item-folder-name nns-icon{
        display: none;
      }
    }
  `, `
    :host-context(.nns-theme-night) .nns-item-folder-link{
      color:rgba(255,255,255, 0.8);
    }
    :host-context(.nns-theme-night) .nns-item-folder-layer {
      border-color: #646A6A;
      background:#292E32;
      box-shadow:4px 4px 38px rgb(19 30 32 / 66%);
    }
    :host-context(.nns-theme-night) .nns-item-folder-link:hover {
      color:#fff;
    }
    :host-context(.nns-theme-night) .nns-item-folder-link:hover .nns-item-folder-main {
      background:rgba(181,181,181,0.10);
    }

    :host-context(.nns-theme-night) .nns-item-folder-link {
      border-color:#2F3737;
    }
    @media print {
      :host-context(.nns-theme-night) .nns-item-folder-name-text {
        color: #161616;
      }
    }
  `],
  template: `
  <a class="nns-item-folder-link" [routerLink]="[urlString]" title="{{item.title | unescape}}">
    <span class="nns-item-folder-layer"></span>
    <span class="nns-item-folder-main" flex layout="column">
      <span class="nns-item-folder-top" flex="none" layout="row" layout-align="start center">
        <span class="nns-item-folder-name" flex layout="row" layout-align="start center">
          <nns-icon flex="none" icon="folder"></nns-icon>
          <span class="nns-item-folder-name-text" [innerHTML]="item.title"></span>
        </span>
        <span class="nns-item-folder-notes" flex="none" layout="row" layout-align="start center">
          <nns-icon flex="none" icon="next-inv"></nns-icon>
        </span>
      </span>
    </span>
  </a>
  `,
})
export class ItemFolderListComponent implements OnInit {
  @Input() public item;
  @Input() public share;
  urlString;

  ngOnInit() {
    const shareInstance = this.share.instance;
    if(this.item.share && this.item.share.passwordRequired) {
      const childShare = this.item.share;
      this.urlString = `/share/${childShare.id}/${childShare.securityKey}`
    } else {
      this.urlString = `/share/${shareInstance.id}/${shareInstance.securityKey}/${this.item.globalId}`;
    }
  }
}
